import React from 'react';

import { SVGComponentProps } from './svg.types';

const WorkspaceSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M1.1665 2.91667C1.1665 2.27233 1.68884 1.75 2.33317 1.75H11.6665C12.3108 1.75 12.8332 2.27233 12.8332 2.91667V5.83333V11.0833C12.8332 11.7277 12.3108 12.25 11.6665 12.25H5.24984H2.33317C2.33065 12.25 2.32814 12.25 2.32563 12.25C1.68477 12.2459 1.1665 11.7251 1.1665 11.0833V5.83333V2.91667ZM2.33317 5.25H5.24984H11.6665V2.91667H2.33317V5.25ZM4.6665 6.41667H2.33317V11.0833H4.6665V6.41667ZM5.83317 11.0833H11.6665V6.41667H5.83317V11.0833Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default WorkspaceSVG;
